// Global scripts

import Lazy from './modules/lazy';

import Header from './parts/header';
import Nav from './parts/nav';

import MainFootbar from './sections/main-footbar';

// Home scripts

import HomeBanner from './sections/home-banner';
import HomeFootbar from './sections/home-footbar';
import HomeHero from './sections/home-hero';
import HomeProducts from './sections/home-products';
import HomeTopbar from './sections/home-topbar';

// About scripts

import AboutFaq from './sections/about-faq';

// Contact scripts

import ContactForm from './components/contact-form';

// Posts scripts

import PostsGrid from './sections/posts-grid';

// Post scripts

// Products scripts

import ProductsBanner from './sections/products-banner';
import ProductsNav from './sections/products-nav';
import ProductsSlider from './sections/products-slider';

// Product scripts

// Locations scripts

import LocationsContent from './sections/locations-content';

// Location scripts

// Landing Rezi scripts

import ReziFootbar from './sections/rezi-footbar';
import ReziProducts from './sections/rezi-products';

// Styles

import '../styles/theme.scss';

// Global scripts

new Lazy;

new Header;
new Nav;

new MainFootbar;

// Home scripts

if (document.body.classList.contains('page-template-home')) {
  new HomeBanner;
  new HomeFootbar;
  new HomeHero;
  new HomeProducts;
  new HomeTopbar;
}

// About scripts

if (document.body.classList.contains('page-template-about')) {
  new AboutFaq;
}

// Contact scripts

if (document.body.classList.contains('page-template-contact')) {
  new ContactForm;
}

// Posts scripts

if (document.body.classList.contains('blog')) {
  new PostsGrid;
}

// Post scripts

if (document.body.classList.contains('single-post')) {
}

// Products scripts

if (document.body.classList.contains('post-type-archive-product')) {
  new ProductsBanner;
  new ProductsNav;
  new ProductsSlider;
}

// Product scripts

if (document.body.classList.contains('single-product')) {
}

// Locations scripts

if (document.body.classList.contains('post-type-archive-location')) {
  new LocationsContent;
}

// Location scripts

if (document.body.classList.contains('single-location')) {
}

// Landing Rezi scripts

if (document.body.classList.contains('page-template-landing-rezi')) {
  new ReziFootbar;
  new ReziProducts;
}
